import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "../app/globals.css";
import "../app/theme.css";

// Handle stale chunk errors after deployment — auto-reload once
window.addEventListener("error", (e) => {
  if (e.message?.includes("Failed to fetch dynamically imported module") ||
      e.message?.includes("Importing a module script failed")) {
    const key = "chunk_reload";
    const last = sessionStorage.getItem(key);
    if (!last || Date.now() - Number(last) > 10000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
});

window.addEventListener("unhandledrejection", (e) => {
  const msg = e.reason?.message || String(e.reason || "");
  if (msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("Importing a module script failed")) {
    const key = "chunk_reload";
    const last = sessionStorage.getItem(key);
    if (!last || Date.now() - Number(last) > 10000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
